import React from 'react';
import { Slider } from 'antd';
import { BTN, C, FONT_UI } from '../../constants/design-tokens';

export const labelStyle: React.CSSProperties = {
  fontSize: 12,
  fontFamily: FONT_UI,
  fontWeight: 600,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: C.textMuted
};

export const valueStyle: React.CSSProperties = {
  fontSize: 12,
  fontFamily: FONT_UI,
  color: C.textMuted,
  fontVariantNumeric: 'tabular-nums'
};

export const rowStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8
};

export const buttonStyle: React.CSSProperties = {
  background: C.surface,
  border: `1px solid ${C.borderHi}`,
  borderRadius: 6,
  padding: '6px 10px',
  fontSize: 12,
  fontFamily: FONT_UI,
  fontWeight: 600,
  color: C.textPrimary,
  cursor: 'pointer'
};

const sliderStyles = {
  rail: { backgroundColor: BTN.secondary.bg, height: 4 },
  track: { backgroundColor: BTN.ghost.bg, height: 4 },
  handle: { borderColor: C.accent, boxShadow: `0 2px 8px ${C.accent}` }
};

type SliderRowProps = {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (v: number) => void;
  onCommit?: () => void;
};

export const SectionTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div
    style={{
      fontSize: 13,
      fontFamily: FONT_UI,
      fontWeight: 700,
      letterSpacing: '0.08em',
      textTransform: 'uppercase',
      color: C.textMuted,
      padding: '12px 14px 6px'
    }}
  >
    {children}
  </div>
);

export const SliderRow: React.FC<SliderRowProps> = ({ label, value, min, max, step, onChange, onCommit }) => (
  <div>
    <div style={rowStyle}>
      <span style={labelStyle}>{label}</span>
      <span style={valueStyle}>{value.toFixed(3)}</span>
    </div>
    <Slider
      min={min}
      max={max}
      step={step}
      value={value}
      onChange={onChange}
      onChangeComplete={onCommit}
      tooltip={{ open: false }}
      styles={sliderStyles}
    />
  </div>
);
